<template>
  <div class="house-importer-finish-stage-check-charges-panel">
    <app-panel :title="panelTitle">

      <div slot="actions" v-if="status === CHARGES_STATUSES.uploaded">
        <app-button @click="resetStatus" color="success">Проверить другой файл</app-button>
      </div>

      <div class="house-importer-finish-stage-check-charges-panel__content">
        <div v-if="status === CHARGES_STATUSES.upload">
          <div class="house-importer-finish-stage-check-charges-panel__main-content">
            <div class="house-importer-finish-stage-check-charges-panel__col house-importer-finish-stage-check-charges-panel__col_file">
              <div class="house-importer-finish-stage-check-charges-panel__info-file" v-if="isFileAlreadyUploaded">
                Файл уже загружен, можете запустить проверку без импорта файла
              </div>
              <div class="house-importer-finish-stage-check-charges-panel__no-file-error" v-if="fileError">
                Выберите файл
              </div>
              <vs-upload
                      action="#"
                      :limit="1"
                      :show-upload-button="false"
                      text="Добавить файл"
                      @change="onFileChange"
                      @on-delete="onFileDelete"
                      class="import-source-stage__uploader import-source-stage__uploader_single"
                      ref="counterUploader"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>
            <div class="house-importer-finish-stage-check-charges-panel__col house-importer-finish-stage-check-charges-panel__col_settings">
              <div class="house-importer-finish-stage-check-charges-panel__col-row">
                <app-input label="Номер строки с названиями тарифов"
                           vtype="uint"
                           v-model="postBody.service_row"
                           :danger.sync="postBodyErrors.service_row"
                           danger-text="Заполните номер строки"
                />
              </div>
              <div class="house-importer-finish-stage-check-charges-panel__col-row">
                <app-input label="Номер первой колонки с начислениями"
                           vtype="uint"
                           v-model="postBody.first_tarif_col"
                           :danger.sync="postBodyErrors.first_tarif_col"
                           danger-text="Заполните номер колонки"
                />
              </div>
              <div class="house-importer-finish-stage-check-charges-panel__col-row">
                <app-datepicker label="Месяц"
                                v-model="postBody.month"
                                format="MMMM yyyy"
                                minimum-view="month"
                />
              </div>
              <div class="house-importer-finish-stage-check-charges-panel__col-row"
                   v-for="(tariffName, index) in tariffsNames" :key="`row-${index}`">
                <ChangeTariffsRow :tariffs="tariffs" class="" :value="tariffName" :tariffsNames="tariffsNames"
                                  @input="setTariffName($event, index)" @delete="deleteTariffName(index)"/>
              </div>
              <div class="house-importer-finish-stage-check-charges-panel__add-tariff">
                <div class="house-importer-finish-stage-check-charges-panel__add-tariff-text link-icon"
                     @click="addTariffName">Добавить тариф
                </div>
              </div>
            </div>
          </div>
          <div style="text-align: center; margin-top: 15px">
            <app-button color="success" @click="getData">Получить данные</app-button>
          </div>

        </div>
        <div class="house-importer-finish-stage-check-charges-panel__loading"
             v-else-if="status === CHARGES_STATUSES.uploading">
          <div class="block-loading"/>
          <div>Получаю данные...</div>
        </div>
        <div v-else-if="status === CHARGES_STATUSES.uploaded">
          <vs-tabs>
            <vs-tab label="Разбиение по тарифам" key="charges-by-tariff">
              <vs-collapse accordion>
                <vs-collapse-item v-for="(charge, tariffId) in charges.mismatches" :key="tariffId" class="house-importer-import-charges-stage-check-charges-panel-collapse-item__collapse-item house-importer-import-charges-stage-check-charges-panel-collapse-item">
                  <div slot="header" class="house-importer-finish-stage-check-charges-panel-collapse-item__header">
                    <span class="house-importer-finish-stage-check-charges-panel-collapse-item__header-text">{{getTariffById(tariffId).name}} <span :style="{color:  `rgba(var(--app-${charge.length ? 'danger' : 'success'}), 1);`}">({{charge.length}})</span></span>
                  </div>

                  <div>
                    <vs-table :data="charge" hoverFlat pagination max-items="20" class="house-importer-finish-stage-check-charges-panel-collapse-item__table" no-data-text="Данных нет">
                      <template slot="thead">
                        <vs-th>Аккаунт ELSA</vs-th>
                        <vs-th>Аккаунт Квартал</vs-th>
                        <vs-th>Начислено в ELSA</vs-th>
                        <vs-th>Начислено в Квартале</vs-th>
                      </template>
                      <template slot-scope="{data}">
                        <vs-tr :key="`${trIndex}`" v-for="(tr, trIndex) in data">
                          <vs-td>{{tr.new.account_number}}</vs-td>
                          <vs-td>{{tr.old.account}}</vs-td>
                          <vs-td>{{tr.new.sum | numberWithSpaces}}</vs-td>
                          <vs-td>{{tr.old.total_sum | numberWithSpaces}}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </vs-tab>
            <vs-tab label="Проверка общей суммы" key="charges-by-total">
              <vs-table :data="charges.total_sum_mismatches" hoverFlat pagination max-items="20" class="house-importer-finish-stage-check-charges-panel-collapse-item__table" no-data-text="Данных нет">
                <template slot="thead">
                  <vs-th>Аккаунт</vs-th>
                  <vs-th>Начислено в ELSA</vs-th>
                  <vs-th>Начислено в Квартале</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="`${trIndex}`" v-for="(tr, trIndex) in data">
                    <vs-td>{{tr.account_number}}</vs-td>
                    <vs-td>{{tr.elsa_sum | numberWithSpaces}}</vs-td>
                    <vs-td>{{tr.kvartal_sum | numberWithSpaces}}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </app-panel>
  </div>
</template>

<script>
  import ChangeTariffsRow from "../../import-charges-stage/components/ChangeTariffsRow";

  let CHARGES_STATUSES = {
    upload: 0,
    uploading: 1,
    uploaded: 2
  };


  export default {
    name: "CheckChargesPanel",
    components: {
      ChangeTariffsRow
    },
    props: {
      importInfo: {}
    },
    data() {
      return {
        charges: {
          mismatches: [],
          total_sum_mismatches: []
        },
        CHARGES_STATUSES: CHARGES_STATUSES,
        status: CHARGES_STATUSES.upload,
        fileError: false,
        file: null,
        tariffsNames: [],
        tariffs: [],
        postBody: {
          service_row: null,
          first_tarif_col: null,
          month: new Date(),
        },
        postBodyErrors: {
          service_row: false,
          first_tarif_col: false,
        },
        isFileAlreadyUploaded: false,
      }
    },
    computed: {
      panelTitle(){
        let subTitle = "";
        if( this.status === CHARGES_STATUSES.uploaded){
          let chargesCount = [].concat(...Object.values(this.charges.mismatches)).length || 0;
          subTitle = `<span style="color: rgba(var(--app-${chargesCount ? 'danger' : 'success'}), 1)">&nbsp;(${chargesCount})</span>`;
        }
        return `Проверка начислений на последующие месяцы${subTitle}`;
      },
      postBodyHasError() {
        return !!Object.values(this.postBodyErrors).filter(v => v).length;
      }
    },
    methods: {
      resetStatus(){
        this.charges = [];
        this.file = null;
        this.status = CHARGES_STATUSES.upload;
      },
      onFileChange(event, files){
        this.file = files.filter(file => !file.remove)[0] || null;
        this.fileError = false;
      },
      onFileDelete(){
        this.file = null;
        this.fileError = false;
      },
      resetPostBodyErrors() {
        this.postBodyErrors.service_row = false;
        this.postBodyErrors.first_tarif_col = false;
      },
      resetPostBody() {
        this.postBody.service_row = null;
        this.postBody.first_tarif_col = null;
      },
      resetImport() {
        this.resetPostBodyErrors();
        this.resetPostBody();
      },
      checkPostBody() {
        if (!this.isFileAlreadyUploaded && this.postBody.service_row === null) {
          this.postBodyErrors.service_row = true;
        }
        if (!this.isFileAlreadyUploaded && this.postBody.first_tarif_col === null) {
          this.postBodyErrors.first_tarif_col = true;
        }
      },
      checkFileError() {
        if (!this.isFileAlreadyUploaded && this.file === null) {
          this.fileError = true;
        }
      },
      addTariffName() {
        let tariffName = {
          elsa_name: null,
          kvartal_name: null
        };
        this.tariffsNames.push(tariffName);
      },
      setTariffName(v, index) {
        this.$set(this.tariffsNames, index, v);
      },
      deleteTariffName(index) {
        this.tariffsNames.splice(index, 1);
      },
      async getData(){
        this.resetPostBodyErrors();
        this.checkPostBody();
        this.checkFileError();

        if(this.postBodyHasError || this.fileError) return false;

        this.status = CHARGES_STATUSES.uploading;

        try{
          let body = Object.assign({
            import_id: this.importInfo.id,
            elsa_tarifs: JSON.stringify(this.tariffsNames.map(v => v.elsa_name)),
            kvartal_tarifs: JSON.stringify(this.tariffsNames.map(v => v.kvartal_name)),
          }, this.postBody);

          if(this.file){
            body.new_charges = this.file;
          }
          else{
            delete body.service_row;
            delete body.first_tarif_col;
          }

          body.month = this.$options.filters.moment(body.month, 'YYYY-MM');

          let bodyFormData = new FormData();

          for(let key in body){
            if(body.hasOwnProperty(key)){
              if(Array.isArray(body[key])){
                for(let i = 0; i < body[key].length; i++){
                  bodyFormData.append(`${key}[${i}]`, body[key][i]);
                }
              }
              else{
                bodyFormData.append(key, body[key])
              }
            }
          }
          let {data} = await this.$http.post('import/houses/check_new_charges', bodyFormData, {
            headers: {
              'Content-Type': 'multipart/form-data;'
            }
          });
          this.charges = data;
          setTimeout(() => {
            this.status = CHARGES_STATUSES.uploaded;
          }, 300);
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
      },
      getTariffById(id){
        let index = this.tariffs.findIndex(t => Number(t.id) === Number(id));
        return index >= 0 ? this.tariffs[index] : {name: 'Unknown tariff'};
      },
      async getTariffs() {
        try {
          let {data} = await this.$http.get('import/houses/tarifs', {params: {import_id: this.importInfo.id}});
          this.tariffs = data;
        } catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.tariffs = []
        }
      }
    },
    created() {
      this.getTariffs();
    },
    mounted() {
      if(this.importInfo.files && this.importInfo.files.new_charges){
        this.isFileAlreadyUploaded = true;
      }
      if(this.importInfo.files_parameters && this.importInfo.files_parameters.charges_check){
        let params = this.importInfo.files_parameters.charges_check;

        this.postBody.month = params.month ? this.$parseDateFromString(params.month) : null;

        let tariffsRows = params.elsa_tarifs.map((elsaId, index) => {
          return {
            elsa_name: elsaId,
            kvartal_name: params.kvartal_tarifs[index]
          }
        });
        this.tariffsNames = tariffsRows;
      }
    }
  }
</script>

<style lang="scss">
  .house-importer-finish-stage-check-charges-panel {

    &__content {
      min-height: 200px;
      position: relative;
    }

    &__main-content {
      display: flex;
      margin: 0 -7.5px;
      height: 100%;
      min-height: 200px;
    }

    &__col {
      padding: 0 7.5px;
      flex: 1;

      &-row{
        margin-bottom: 15px;
      }


      &_file {
        display: flex;
        max-width: 40%;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      &_settings {
        width: 60%;
        border-left: 1px solid rgba(0, 0, 0, .2);
      }
    }

    .import-source-stage__uploader_single {
      height: auto;
    }

    .con-img-upload {
      margin: 0 auto;
    }

    &__info-file{
      text-align: center;
      line-height: 1.1;
      font-size: 12px;
    }

    &__no-file-error {
      text-align: center;
      color: rgba(var(--app-danger), 1);
      margin-bottom: 5px;
      font-weight: 500;
    }

    &__add-tariff {
      margin-bottom: 15px;
      text-align: center;

      &-text {
        display: inline-block;
        font-size: 12px;
      }
    }

    .con-img-upload .img-upload {
      margin: 0 -.6em;
    }

    &__loading {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .block-loading {
        width: 60px;
        height: 60px;
        flex: 0;
        margin-bottom: 15px;
      }
    }
  }

  .house-importer-finish-stage-check-charges-panel-collapse-item{
    .vs-collapse-item--header{
      padding: 15px 5px;
      font-size: 18px;
    }

    &.vs-collapse-item{
      border-bottom: 1px solid rgba(0,0,0,.2);
    }

    &.open-item .con-content--item{
      padding: 5px 5px 15px!important;
    }

    &__header{
      display: flex;
      align-items: center;

      &-text{
        font-size: 18px;
        line-height: 1.1;
        text-transform: capitalize;
      }
    }

    &__table{
      .vs-table--tbody{
        border: none;
        background: #fff;
      }

      .vs-table--thead th{
        padding: 0!important;
        border-bottom: 1px solid rgba(0,0,0,.125);

        .vs-table-text{
          text-align: left;
          position: relative;
          vertical-align: bottom;
          padding: .75rem 10px;
          background: transparent;
          font-size: 12px;
        }
      }

      .vs-table{
        .vs-table--tr:nth-child(2n+1){
          background: #f5f8fa;
        }
      }

      .tr-values td{
        padding: .5rem 10px;
        font-size: 12px;
      }

      .vs-table--pagination{
        justify-content: center;
      }
    }

    &__no-data{
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 16px;
    }
  }
</style>